<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] bg-white cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ items[0].value.text }}
    </div>
    <div class="flex gap-6 items-center justify-center">
      <p-rating [stars]="items[1].value.numberOfStars" (onRate)="submitRating($event)" />
    </div>
  </div>
</div>
